/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import apiService from './index'

const BASE = process.env.REACT_APP_BACKEND_URL_V3 ?? ''

export const getPublicPlans = async () => {
  return apiService.get(`${BASE}/plans`)
}

export const getAutoApplyCoupon = async (planId: string) => {
  if (!planId) throw new Error('planId is required')
  const qs = `planId=${encodeURIComponent(planId)}`
  return apiService.get(`${BASE}/plans/auto-apply-coupon?${qs}`)
}

export const validateCoupon = async (planId: string, code: string) => {
  if (!planId) throw new Error('planId is required')
  if (!code) throw new Error('code is required')
  const qs = `planId=${encodeURIComponent(planId)}&code=${encodeURIComponent(code)}`
  return apiService.get(`${BASE}/plans/validate-coupon?${qs}`)
}

export default {
  getPublicPlans,
  getAutoApplyCoupon,
  validateCoupon,
}
